import { BehaviorSubject, Observable, map } from 'rxjs';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';

import { GridApi } from 'ag-grid-community';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  gridApi = new BehaviorSubject<GridApi | null>(null); // Store Grid API globally
  isCollapsed = new BehaviorSubject(false)
  CurrentNavActiveItem = new BehaviorSubject([])
  public extraNavActiveItem = new BehaviorSubject('')
  public vendorId = new BehaviorSubject<string>(sessionStorage.getItem('currentActiveInstitution') || '')
  public currentActiveModule = new BehaviorSubject('')
  sidebarToggled: any;
  laptopView: any = window.innerWidth >= 992;
  baseUrl: any = environment.apiBaseUrl
  private rawHttp: HttpClient;

  constructor(public http: HttpClient, private handler: HttpBackend) {
    this.rawHttp = new HttpClient(handler);
    const screenWidth = window.innerWidth;
    this.laptopView = screenWidth >= 992;
    this.isCollapsed.next(screenWidth < 992);
  }

  callPostAPI(path: string, payload: any, type?: any) {
    const currentUrl = window.location.href;
    if (currentUrl.includes('eCards')) {
      this.baseUrl = environment.apiBaseUrl + '/eCards';
    }
    if (currentUrl.includes('eBank')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    if (currentUrl.includes('smart-routing')) {
      this.baseUrl = environment.pgAPIUrl + '/gateway';
    }
    else if (currentUrl.includes('pg')) {
      this.baseUrl = environment.apiBaseUrl + '/pg';
    }
    if (currentUrl.includes('setup-charges') || currentUrl.includes('fms-access')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    if (currentUrl.includes('tickets')) {
      this.baseUrl = environment.apiBaseUrl;
    }
    if (currentUrl.includes('ePG')) {
      this.baseUrl = environment.apiBaseUrl;
    }
    if(currentUrl.includes('user-management')) {
      this.baseUrl = environment.apiBaseUrl;
    }
    let apiPath = this.baseUrl + path;

    if (type == 'cards') {
      apiPath = this.baseUrl + '/cards' + path;
    } else if (type == 'cardfunction') {
      apiPath = this.baseUrl + '/cards/cardfunction' + path;
    }
    else if (type == 'eBank') {
      apiPath = environment.apiBaseUrl + '/eBank' + path;
    }
    else if (type == 'ePG') {
      apiPath = environment.apiBaseUrl + '/ePG' + path;
    }
    return this.http.post<any>(apiPath, payload);
  }

  callGenericPostAPI(fullPath: string, payload: any) {
    let apiPath = environment.apiBaseUrl + fullPath;
    return this.http.post<any>(apiPath, payload);
  }

  callGenericGETAPI(fullPath: string) {
    let apiPath = environment.apiBaseUrl + fullPath;
    return this.http.get<any>(apiPath);
  }

  callGenericPostAPI2(fullPath: string, payload: any) {
    let apiPath = environment.apiBaseUrl3 + fullPath;
    return this.http.post<any>(apiPath, payload);
  }

  callGenericGETAPI2(fullPath: string) {
    let apiPath = environment.apiBaseUrl3 + fullPath;
    return this.http.get<any>(apiPath);
  }

  callGetAPI(path: string, type?: any) {
    const currentUrl = window.location.href;
    if (currentUrl.includes('eCards')) {
      this.baseUrl = environment.apiBaseUrl + '/eCards';
    }
    if (currentUrl.includes('eBank')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    if (currentUrl.includes('smart-routing')) {
      this.baseUrl = environment.pgAPIUrl + '/gateway';
    }
    else if (currentUrl.includes('pg')) {
      this.baseUrl = environment.apiBaseUrl + '/pg';
    }
    if (currentUrl.includes('setup-charges') || currentUrl.includes('fms-access')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    if (currentUrl.includes('tickets')) {
      this.baseUrl = environment.apiBaseUrl;
    }
     if(currentUrl.includes('user-management')) {
      this.baseUrl = environment.apiBaseUrl;
    }
    let apiPath = this.baseUrl + path;

    if (type == 'cards') {
      apiPath = this.baseUrl + '/cards' + path;
    } else if (type == 'cardfunction') {
      apiPath = this.baseUrl + '/cards/cardfunction' + path;
    }
    else if (type == 'eBank') {
      apiPath = environment.apiBaseUrl + '/eBank' + path;
    }
    else if (type == 'ePG') {
      apiPath = environment.apiBaseUrl + '/ePG' + path;
    }
    return this.http.get<any>(apiPath);
  }

  callLogoutAPI(path: string) {
    this.baseUrl = environment.apiBaseUrl + '/eBank';
    let apiPath = this.baseUrl + path;
    return this.http.get<any>(apiPath);

  }

  callPutAPI(path: string, payload: any, type?: any) {
    const currentUrl = window.location.href;
    if (currentUrl.includes('eCards')) {
      this.baseUrl = environment.apiBaseUrl + '/eCards';
    }
    if (currentUrl.includes('eBank')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    if (currentUrl.includes('pg')) {
      this.baseUrl = environment.apiBaseUrl + '/pg';
    }
    if (currentUrl.includes('setup-charges') || currentUrl.includes('fms-access')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    let apiPath = this.baseUrl + path;
    if (type == 'cards') {
      apiPath = this.baseUrl + '/cards' + path;
    } else if (type == 'cardfunction') {
      apiPath = this.baseUrl + '/cards/cardfunction' + path;
    }
    return this.http.put<any>(apiPath, payload);
  }

  callDeleteAPI(path: string, type?: any) {
    const currentUrl = window.location.href;
    if (currentUrl.includes('eCards')) {
      this.baseUrl = environment.apiBaseUrl + '/eCards';
    }
    if (currentUrl.includes('eBank')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    if (currentUrl.includes('pg')) {
      this.baseUrl = environment.apiBaseUrl + '/pg';
    }
    if (currentUrl.includes('setup-charges')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    let apiPath = this.baseUrl + path;
    if (type == 'cards') {
      apiPath = this.baseUrl + '/cards' + path;
    } else if (type == 'cardfunction') {
      apiPath = this.baseUrl + '/cards/cardfunction' + path;
    }
    return this.http.delete<any>(apiPath);
  }

  getJSON(type: any): Observable<any> {
    if (type == 'language') {
      return this.http.get<any>('assets/json/language.json')
    }
    else if (type == 'id') {
      return this.http.get<any>('assets/json/id.json')
    }
    else if (type == 'currency') {
      return this.http.get<any>('assets/json/currency.json')
    }
    else {
      return this.http.get<any>('assets/json/country.json')
    }
  }

  getCountryList() {
    const currentUrl = window.location.href;
    if (currentUrl.includes('eCards')) {
      this.baseUrl = environment.apiBaseUrl + '/eCards';
    }
    if (currentUrl.includes('eBank')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    if (currentUrl.includes('pg')) {
      this.baseUrl = environment.apiBaseUrl + '/pg';
    }
    if (currentUrl.includes('setup-charges')) {
      this.baseUrl = environment.apiBaseUrl + '/eBank';
    }
    if (currentUrl.includes('user-management')) {
      this.baseUrl = environment.apiBaseUrl + '/ePG';
    }
    return this.http.get<any>(this.baseUrl + '/get-country-currency-list');
  }


  callPostAPI2(path: string, payload: any) {
    return this.http.post<any>(environment.apiBaseUrl2 + path, payload);
  }
  callGetAPI2(path: string) {
    return this.http.get<any>(environment.apiBaseUrl2 + path);
  }


  CallPgPOSTAPI(path: string, payload: any) {
    return this.http.post<any>(environment.pgUrlNew + path, payload);
  }

  CallPgPOSTAPINoHeader(path: string, payload: any) {
    const xToken = sessionStorage.getItem('x-token') || sessionStorage.getItem('loggedCode') || sessionStorage.getItem('token') || 'OjekDstnA8TxJ0bREVU47BhPS2kQrWukuMZfuqTKAnBxMkI+raNtiljSW67udwPIZAy6OZIu6+dOm2FdhGsi9Wbid58FtZX50Oc=';
    const checksum = sessionStorage.getItem('checksum') || '5893GMP735680827';
    const headers = new HttpHeaders({
      'accept': 'application/json',
      'content-type': 'application/json',
      'x-token': xToken,
      'checksum': checksum
    });
    return this.rawHttp.post<any>(environment.pgUrlNew + path, payload, { headers });
  }

  // Use this method for FormData/file uploads — NO content-type header
  // so the browser auto-sets multipart/form-data with the correct boundary
  CallPgPOSTAPIFormData(path: string, formData: FormData) {
    const xToken = sessionStorage.getItem('x-token') || sessionStorage.getItem('loggedCode') || sessionStorage.getItem('token') || 'OjekDstnA8TxJ0bREVU47BhPS2kQrWukuMZfuqTKAnBxMkI+raNtiljSW67udwPIZAy6OZIu6+dOm2FdhGsi9Wbid58FtZX50Oc=';
    const checksum = sessionStorage.getItem('checksum') || '5893GMP735680827';
    const headers = new HttpHeaders({
      'x-token': xToken,
      'checksum': checksum
      // NOTE: DO NOT set 'content-type' here — browser must set multipart/form-data + boundary automatically
    });
    return this.rawHttp.post<any>(environment.pgUrlNew + path, formData, { headers });
  }

  CallPgPOSTAPIWithoutHeader(path: string, payload: any) {
    return this.CallPgPOSTAPINoHeader(path, payload);
  }

  callPgGETAPI(path: string) {
    return this.http.get<any>(environment.pgUrlNew + path);
  }

  CallPgGETAPINoHeader(path: string) {
    const xToken = sessionStorage.getItem('x-token') || sessionStorage.getItem('loggedCode') || sessionStorage.getItem('token') || 'OjekDstnA8TxJ0bREVU47BhPS2kQrWukuMZfuqTKAnBxMkI+raNtiljSW67udwPIZAy6OZIu6+dOm2FdhGsi9Wbid58FtZX50Oc=';
    const checksum = sessionStorage.getItem('checksum') || '5893GMP735680827';
    const headers = new HttpHeaders({
      'accept': 'application/json',
      'content-type': 'application/json',
      'x-token': xToken,
      'checksum': checksum
    });
    return this.rawHttp.get<any>(environment.pgUrlNew + path, { headers });
  }

  CallPgPOSTAPI1(path: string, payload: any) {
    return this.http.post<any>(environment.pgUrlNew1 + path, payload);
  }

  callPgGETAPI1(path: string) {
    return this.http.get<any>(environment.pgUrlNew1 + path);
  }

  callReportPostAPI(path: string, payload: any) {
  return this.http.post<any>(environment.pgAPIUrl + path, payload);
}

  // Method to trigger grid resize
  resizeGrid() {
    const api = this.gridApi.getValue();
    if (api) {
      setTimeout(() => {
        api.redrawRows()
        if (this.laptopView) {
          api.sizeColumnsToFit();
        }
      }, 500);
    }
  }
}
